import { render } from "./TextareaLang.vue?vue&type=template&id=04907702"
import script from "./TextareaLang.vue?vue&type=script&lang=js"
export * from "./TextareaLang.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__